import React, { Component } from "react";
import PropTypes from "prop-types";
import { observable } from "mobx";
import { observer } from "mobx-react";
import ErrorWrapper from "~/components/wrapper/ErrorWrapper";
import ContentLoader from "~/components/element/ContentLoader";
import NotAuthorizedPage from "~/components/element/NotAuthorizedPage";
import RouteWrapper from "~/components/wrapper/RouteWrapper";
import CustomerStore from "~/stores/CustomerStore";
import User from "~/models/User";

@observer
class LoggedInCustomerWrapper extends Component {
  @observable customerStore = null;

  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      notAuthorized: false,
    };

    this.customerStore = new CustomerStore();
  }

  componentDidMount() {
    const { user, showError } = this.props;
    const { userId } = user;

    if (!user.isCustomer) {
      this.setState({ notAuthorized: true });
      return;
    }

    this.customerStore
      .load(userId)
      .then(() => {
        this.setState({ isLoading: false });
      })
      .catch(error => {
        if (error.message.startsWith("Access denied")) {
          this.setState({ notAuthorized: true });
        } else {
          showError(error.message);
        }

        this.setState({ isLoading: false });
      });
  }

  render() {
    const { children } = this.props;
    const { isLoading, notAuthorized } = this.state;

    // Only the first loading
    // At any subsequent loading we do not want all the components to unmount
    if (isLoading) {
      return <ContentLoader />;
    }

    if (notAuthorized) {
      return <NotAuthorizedPage />;
    }

    return children({ customerStore: this.customerStore });
  }
}

LoggedInCustomerWrapper.propTypes = {
  user: PropTypes.instanceOf(User),
  children: PropTypes.func.isRequired,
};

export default ErrorWrapper(RouteWrapper(LoggedInCustomerWrapper));
